'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroups$002dView$0024$0024anon$002414 from "./presto.-Groups-View$$anon$14.js";
import * as $j_presto$002e$002dGroups$002dView$0024$0024anon$002416 from "./presto.-Groups-View$$anon$16.js";
import * as $j_presto$002etypes$0024$002dGroup from "./presto.types$-Group.js";
import * as $j_presto$002etypes$0024$002dGroup$002dCode$0024 from "./presto.types$-Group-Code$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dId$0024 from "./presto.types$-Group-Id$.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024 from "./presto.types$-Group-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$13() {
  this.aWr = null;
  this.aWj = null;
  this.aWk = false;
  this.aWs = null;
  this.aWt = false;
  this.aWw = null;
  this.aWp = null;
  this.aWq = false;
  this.aWl = null;
  this.aWm = false;
  this.aWn = null;
  this.aWo = false;
  this.aWu = false;
  this.aWv = false;
  this.aWr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aWw = "Group";
}
export { $c_Lpresto_GroupsView$$anon$13 as $c_Lpresto_GroupsView$$anon$13 };
$p = $c_Lpresto_GroupsView$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$13;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$13() {
}
export { $h_Lpresto_GroupsView$$anon$13 as $h_Lpresto_GroupsView$$anon$13 };
$h_Lpresto_GroupsView$$anon$13.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aWr;
});
$p.L = (function() {
  if ((!this.aWk)) {
    this.aWj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aWk = true;
  }
  return this.aWj;
});
$p.O = (function() {
  if ((!this.aWt)) {
    this.aWs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aWt = true;
  }
  return this.aWs;
});
$p.E = (function() {
  return this.aWw;
});
$p.t = (function() {
  if ((!this.aWq)) {
    this.aWp = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("roles", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aWq = true;
  }
  return this.aWp;
});
$p.M = (function() {
  if ((!this.aWm)) {
    this.aWl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dId$0024.$m_Lpresto_types$GroupId$().p2(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dCode$0024.$m_Lpresto_types$GroupCode$().iJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGroup$002dName$0024.$m_Lpresto_types$GroupName$().me(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dGroups$002dView$0024$0024anon$002414.$c_Lpresto_GroupsView$$anon$14())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.aWm = true;
  }
  return this.aWl;
});
$p.Q = (function() {
  if ((!this.aWo)) {
    this.aWn = ($j_presto$002etypes$0024$002dGroup.$m_Lpresto_types$Group$(), new $j_presto$002e$002dGroups$002dView$0024$0024anon$002416.$c_Lpresto_GroupsView$$anon$16());
    this.aWo = true;
  }
  return this.aWn;
});
$p.w = (function() {
  if ((!this.aWv)) {
    this.aWu = ($j_presto$002etypes$0024$002dGroup.$m_Lpresto_types$Group$(), false);
    this.aWv = true;
  }
  return this.aWu;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee213) => ((p) => \u03b4scrutinee213.oZ(p)))($j_presto$002etypes$0024$002dGroup.$m_Lpresto_types$Group$())));
});
var $d_Lpresto_GroupsView$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$13, "presto.GroupsView$$anon$13", ({
  Jt: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_GroupsView$$anon$13 as $d_Lpresto_GroupsView$$anon$13 };
//# sourceMappingURL=presto.-Groups-View$$anon$13.js.map
